// plugins/antd.js
import Vue from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css' // 引入 Ant Design Vue 样式

Vue.use(Antd)
